export const dealUrl = "https://api.hoconinfo.com/getdeals.php";
export const storeUrl = "https://api.hoconinfo.com/getstores.php";
export const categoryUrl = "https://api.hoconinfo.com/getcategories.php";
export const variationUrl = "https://api.hoconinfo.com/getVariations.php";

export const categoryNames = {
    1: 'Amazon',
    3: '流行時尚',
    5: '美容保健',
    7: '運動休閒',
    9: '工具園藝',
    10: 'Subscribe & Save',
    11: '居家生活',
    13: '科技家電',
    15: '兒童玩具',
    23: '省錢秘笈',
    25: '熱門好康',
    42: '必看好康',
    101: '購物教學',
    104: 'Memorial Day Sale',
    105: 'Prime Day Sale'
};

export const amazonCategoryAds = {
    3: `<div id="amzn-assoc-ad-e79a001d-759a-4f6b-9454-302fba516970"></div><script async src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=e79a001d-759a-4f6b-9454-302fba516970"></script>`,
    5: `<div id="amzn-assoc-ad-44226875-b50e-4424-830e-535f6ec85f44"></div><script async src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=44226875-b50e-4424-830e-535f6ec85f44"></script>`,
    7: `<div id="amzn-assoc-ad-39e23e7b-3b5c-4dc0-b3fa-38f41265ab4e"></div><script async src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=39e23e7b-3b5c-4dc0-b3fa-38f41265ab4e"></script>`,
    9: `<div id="amzn-assoc-ad-789a5938-2f26-4357-8fee-d43134a49dce"></div><script async src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=789a5938-2f26-4357-8fee-d43134a49dce"></script>`,
    11: `<div id="amzn-assoc-ad-596d9ed8-a390-4a47-9455-3d7f4db90a6c"></div><script async src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=596d9ed8-a390-4a47-9455-3d7f4db90a6c"></script>`,
    13: `<div id="amzn-assoc-ad-64519297-dcfb-406d-9d21-86493ddc2b6a"></div><script async src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=64519297-dcfb-406d-9d21-86493ddc2b6a"></script>`,
    15: `<div id="amzn-assoc-ad-8f7e14cf-c1d3-4544-98b3-aae3a583692d"></div><script async src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=8f7e14cf-c1d3-4544-98b3-aae3a583692d"></script>`,
};